export interface ServiceList extends Record<string, string> {}

const getServiceList = async (): Promise<ServiceList> => {
  if (process.env.goal === 'local') {
    // we only want to import this in local mode, to prevent including the secret service list in the production bundle
    const json = (await import('./serviceList.json')).default as ServiceList;

    // remove the comments
    return Object.fromEntries(
      Object.entries(json).filter(([key]) => !key.startsWith('_'))
    );
  }

  // return an empty service list
  return {};
};

/** Maps a generated unique, human-readable SERVICE_PATH to its query string. */
export const serviceListPromise = getServiceList();
